import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { RefreshTokenParams } from '@repo/user-types'

const initialRefreshTokenState: GenericOperationState<null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: refreshTokenDeviceActions, reducer: refreshTokenDeviceReducer } =
  createOperationSlice<null, SliceCaseReducers<GenericOperationState<null>>, RefreshTokenParams>({
    name: '@users/devices/refresh-token',
    initialState: initialRefreshTokenState,
    reducers: {},
  })
